import { useEffect, useState } from 'react'

/**
 * Returns a `Date.now()` value that refreshes on a fixed interval, so
 * components rendering relative timestamps ("5m ago", "now") re-render
 * periodically and the displayed age stays live instead of freezing at the
 * value computed on first render. Pass the result to time formatters that
 * accept a `now` argument (`formatRelative`, `ageFromMs`,
 * `threadAgeDisplay`). Default 30s — coarse enough for "ago" labels without
 * spinning a busy timer.
 */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
